import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
export const rangeAccrualSchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.RangeAccrual),
    coupon_rate_annual: z.number(),
    coupon_yearly_observations: z.number().min(1),
    contract_type: contractTypeSchema,
    knockdown_input_level: knockdownInputLevelSchema,
});
